import type { ReactNode } from 'react'
import type { Control, UseFormSetValue } from 'react-hook-form'

import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form'
import { MemberRoleSelect } from './member-role-select.molecule'
import type { OrganizationRoleKey } from './members.interface'
import type { InviteMemberFormSchemaType } from './members.schema'

interface InviteMemberRoleFieldProps {
  control: Control<InviteMemberFormSchemaType>
  setValue: UseFormSetValue<InviteMemberFormSchemaType>
  isDisabled?: boolean
}

export const InviteMemberRoleField: React.FC<InviteMemberRoleFieldProps> = ({
  control,
  setValue,
  isDisabled = false,
}): ReactNode => {
  const handleRoleChange = (memberRole: OrganizationRoleKey): void => {
    setValue('memberRole', memberRole, { shouldValidate: true })
  }

  return (
    <FormField
      control={control}
      name="memberRole"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Role</FormLabel>
          <FormControl>
            <MemberRoleSelect
              value={field.value}
              onChange={handleRoleChange}
              isDisabled={isDisabled}
              className="invite-member-role-select w-full"
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}

InviteMemberRoleField.displayName = 'InviteMemberRoleField'
